import { CommonModule } from '@angular/common';
import { Component, input, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { getNewFileFormGroup } from '@app/helpers/form.helper';
import { FileUploadControl } from '@app/models/form.models';
import { FileType } from '@app/models/shared.enums';
import { TranslateModule } from '@ngx-translate/core';
import { UploadFilesComponent } from '../../common/upload-files/upload-files.component';
import { DocumentUploadFormGroup } from './document-upload-form.helper';

@Component({
  selector: 'app-document-upload-form',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    UploadFilesComponent,
  ],
  templateUrl: './document-upload-form.component.html',
  styleUrl: './document-upload-form.component.scss',
})
export class DocumentUploadFormComponent implements OnInit {
  public formGroupInput = input.required<FormGroup<DocumentUploadFormGroup>>();
  public authFromPartner?: FormArray<FormGroup<FileUploadControl>>;
  authFromRepresentative?: FormArray<FormGroup<FileUploadControl>>;
  signatureOfAuthFromRepresentative?: FormArray<FormGroup<FileUploadControl>>;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.authFromPartner = this.fb.array([
      this.formGroupInput().controls.authPartner,
    ]);
    this.authFromRepresentative = this.fb.array([
      this.formGroupInput().controls.authRepresentative,
    ]);
    this.signatureOfAuthFromRepresentative = this.fb.array([
      this.formGroupInput().controls.signature,
    ]);
  }

  createNewFileGroup(
    formArray: FormArray<FormGroup<FileUploadControl>>,
    fileType: FileType,
  ) {
    formArray.push(getNewFileFormGroup(this.fb, fileType));
    this.authFromPartner = formArray;
  }
}
